/* Poolfritz – Konfigurator fuer GFK-Becken.
   Datenbasis: JSON aus der Section (Metafelder modell.*), Farb-/Optionsbilder aus Shopify-Dateien.
   Keine Preise, keine berechneten technischen Werte. PDF mit jsPDF (cdnjs), Versand wie Ueberdachungs-Konfigurator. */
(function () {
  'use strict';
  var root = document.querySelector('[data-pfk]');
  if (!root) return;

  var daten = [], cfg = {};
  try { daten = JSON.parse(root.querySelector('[data-pfk-daten]').textContent); } catch (e) { daten = []; }
  try { cfg = JSON.parse(root.querySelector('[data-pfk-cfg]').textContent); } catch (e) { cfg = {}; }
  daten.sort(function (a, b) { return (a.lmax || 0) - (b.lmax || 0); });
  var nachHandle = {}; daten.forEach(function (d) { nachHandle[d.h] = d; });

  var SPEICHER = 'pfk_becken_konfiguration';
  var MAX = 8;

  /* ---------- Icons (Linien-Icons, 24x24) ---------- */
  function svg(p) { return '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + p + '</svg>'; }
  var I = {
    schwimmen: svg('<circle cx="16.5" cy="6" r="1.8"/><path d="M4 12.5l4.5-3 3.5 2.5 3-2"/><path d="M2 17c1.5 1.2 3 1.2 4.5 0s3-1.2 4.5 0 3 1.2 4.5 0 3-1.2 4.5 0"/>'),
    sitzbank: svg('<path d="M4 11h16"/><path d="M6 11v6M18 11v6"/><path d="M5 7h14"/><path d="M2 20c1.5 1 3 1 4.5 0s3-1 4.5 0 3 1 4.5 0 3-1 4.5 0"/>'),
    wellness: svg('<path d="M12 3c2 2.5 2 4.5 0 7-2-2.5-2-4.5 0-7z"/><path d="M7 7c2.5.5 3.8 2 4 4.5-2.5-.3-3.8-1.8-4-4.5zM17 7c-2.5.5-3.8 2-4 4.5 2.5-.3 3.8-1.8 4-4.5z"/><path d="M3 16c1.5 1.2 3 1.2 4.5 0s3-1.2 4.5 0 3 1.2 4.5 0 3-1.2 4.5 0"/><path d="M3 20c1.5 1.2 3 1.2 4.5 0s3-1.2 4.5 0 3 1.2 4.5 0 3-1.2 4.5 0"/>'),
    sonne: svg('<circle cx="12" cy="9" r="3.5"/><path d="M12 2v1.5M5 9H3.5M20.5 9H19M7 4l1 1M17 4l-1 1"/><path d="M2 17c1.5 1.2 3 1.2 4.5 0s3-1.2 4.5 0 3 1.2 4.5 0 3-1.2 4.5 0"/><path d="M2 21c1.5 1.2 3 1.2 4.5 0s3-1.2 4.5 0 3 1.2 4.5 0 3-1.2 4.5 0"/>'),
    rollladen: svg('<rect x="3" y="4" width="18" height="16" rx="1.5"/><path d="M3 8h18M3 12h18M3 16h18"/>'),
    rand: svg('<path d="M3 8h18v10H3z"/><path d="M3 11h18"/><path d="M6 14.5c1 .7 2 .7 3 0s2-.7 3 0 2 .7 3 0 2-.7 3 0"/>'),
    lineal: svg('<rect x="2" y="8" width="20" height="8" rx="1"/><path d="M6 8v3M10 8v4M14 8v3M18 8v4"/>'),
    treppe: svg('<path d="M3 20h5v-4h4v-4h4V8h5"/>'),
    wand: svg('<path d="M4 4v16M8 4v16M12 4v16"/><path d="M16 4v16" stroke-dasharray="2 2"/><path d="M20 4v16"/>'),
    schild: svg('<path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6z"/><path d="M9 12l2 2 4-4"/>'),
    farbe: svg('<path d="M12 3a9 9 0 100 18c1.2 0 2-.8 2-1.8 0-.5-.2-.9-.5-1.2-.3-.4-.5-.8-.5-1.2 0-1 .8-1.8 1.8-1.8H17a4 4 0 004-4c0-4.4-4-8-9-8z"/><circle cx="7.5" cy="11" r="1"/><circle cx="10" cy="7" r="1"/><circle cx="14.5" cy="7" r="1"/>'),
    daemmung: svg('<path d="M4 5v14M20 5v14"/><path d="M8 7c2 1 2 3 0 4s-2 3 0 4 2 3 0 4M12 5c2 1 2 3 0 4s-2 3 0 4 2 3 0 4M16 7c2 1 2 3 0 4s-2 3 0 4 2 3 0 4"/>'),
    spreizer: svg('<path d="M3 12h18"/><path d="M6 9l-3 3 3 3M18 9l3 3-3 3"/><path d="M3 5v14M21 5v14"/>'),
    skimmer: svg('<rect x="4" y="6" width="16" height="10" rx="1.5"/><path d="M7 16v3h10v-3"/><path d="M7 10c1.5 1 3.5 1 5 0s3.5-1 5 0"/>'),
    edelstahl: svg('<circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/><path d="M12 4v2M12 18v2M4 12h2M18 12h2"/>'),
    licht: svg('<path d="M9 17h6M10 20h4"/><path d="M12 3a6 6 0 00-3.5 10.9c.6.5 1 1.2 1 2.1h5c0-.9.4-1.6 1-2.1A6 6 0 0012 3z"/>'),
    werkzeug: svg('<path d="M14.7 6.3a4 4 0 00-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 005.4-5.4l-2.5 2.5-2.5-.5-.5-2.5z"/>'),
    filter: svg('<path d="M4 4h16l-6 8v6l-4 2v-8z"/>'),
    tropfen: svg('<path d="M12 3c3.5 4.5 6 7.5 6 11a6 6 0 01-12 0c0-3.5 2.5-6.5 6-11z"/><path d="M9.5 14.5a2.5 2.5 0 002.5 2.5"/>'),
    strom: svg('<path d="M3 8c2 1.5 4 1.5 6 0s4-1.5 6 0"/><path d="M3 13c2 1.5 4 1.5 6 0s4-1.5 6 0"/><path d="M3 18c2 1.5 4 1.5 6 0s4-1.5 6 0"/><path d="M17 13h5M19.5 10.5L22 13l-2.5 2.5"/>'),
    massage: svg('<circle cx="7" cy="16" r="1.5"/><circle cx="12" cy="16" r="1.5"/><circle cx="17" cy="16" r="1.5"/><path d="M7 12V8M12 11V5M17 12V8"/>'),
    dach: svg('<path d="M3 17c0-6 4-10 9-10s9 4 9 10"/><path d="M3 17h18"/><path d="M7 12.5v4.5M12 9v8M17 12.5v4.5"/>'),
    deck: svg('<path d="M3 10h18v8H3z"/><path d="M7 10v8M11 10v8M15 10v8M19 10v8"/>'),
    lkw: svg('<path d="M2 6h11v10H2zM13 10h4l3 3v3h-7z"/><circle cx="6" cy="17.5" r="1.8"/><circle cx="16.5" cy="17.5" r="1.8"/>'),
    bagger: svg('<path d="M3 18h10v-4H5z"/><path d="M13 14l3-6 4 3-2 3"/><path d="M18 14l2 3h-4z"/><circle cx="5" cy="19.5" r="1"/><circle cx="11" cy="19.5" r="1"/>'),
    kalender: svg('<rect x="3" y="5" width="18" height="16" rx="1.5"/><path d="M3 10h18M8 3v4M16 3v4"/>'),
    haus: svg('<path d="M3 11l9-7 9 7"/><path d="M5 10v10h14V10"/><path d="M10 20v-5h4v5"/>'),
    info: svg('<circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/>'),
    thermo: svg('<path d="M14 14.8V5a2 2 0 10-4 0v9.8a4 4 0 104 0z"/><path d="M12 11v6"/>'),
    alle: svg('<rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>')
  };

  /* Nutzungswuensche -> Metafeld becken_merkmale */
  var NUTZUNG = [
    { w: 'Volle Schwimmlänge', t: 'Schwimmen', s: 'Die Treppe verkürzt die Schwimmbahn nicht.', i: 'schwimmen' },
    { w: 'Sitzbank', t: 'Entspannen', s: 'Mit Sitzbank im Becken.', i: 'sitzbank' },
    { w: 'Wellness-/Relaxbecken', t: 'Wellness', s: 'Kleines Relax- und Wellnessbecken.', i: 'wellness' },
    { w: 'Flachwasserzone', t: 'Sonnen im Wasser', s: 'Mit Flachwasserzone zum Liegen.', i: 'sonne' },
    { w: 'Unterflurrollladen möglich', t: 'Unsichtbare Abdeckung', s: 'Unterflur-Rollladen möglich.', i: 'rollladen' },
    { w: 'Ohne Sichtrand', t: 'Moderne Optik', s: 'Ohne umgelegten Sichtrand.', i: 'rand' }
  ];

  /* Optionen aus Metafeld modell.optionen -> Gruppe, Icon, kurze Erklaerung */
  var OPT_REGELN = [
    { r: /Vollisolation/i, g: 'becken', i: 'daemmung', s: 'Isolierte Seitenwände – die Wärme bleibt länger im Wasser.' },
    { r: /Verstärkte Variante/i, g: 'becken', i: 'schild', s: 'Verstärkter Beckenkörper, wenn ohne Beton hinterfüllt werden soll.' },
    { r: /Beckenspreizer/i, g: 'becken', i: 'spreizer', s: 'Halten das Becken beim Einbau und Hinterfüllen in Form.' },
    { r: /Empfohlene Einbauteile/i, g: 'einbau', i: 'skimmer', b: 'wassertechnik', s: 'Die passenden Einbauteile zum Modell – für saubere Wasserzirkulation und Licht im Pool.' },
    { r: /HWL-Skimmer/i, g: 'einbau', i: 'rand', s: 'Für einen höher gesetzten Wasserspiegel – das Wasser steht fast bis zum Beckenrand.', hwl: true },
    { r: /B500/i, g: 'einbau', i: 'edelstahl', s: 'Skimmer aus Edelstahl in schlanker Bauform.' },
    { r: /Edelstahl/i, g: 'einbau', i: 'edelstahl', s: 'Hochwertige Einbauteile aus Edelstahl.' },
    { r: /Montage der Einbauteile/i, g: 'einbau', i: 'werkzeug', s: 'Ausschnitte und Einbau der gewählten Einbauteile am Becken.' },
    { r: /Rollladenschacht/i, g: 'abdeckung', i: 'rollladen', b: 'rollladen', s: 'Der Rollladen verschwindet im Schacht unter einer hochklappbaren Abdeckung bzw. Sitzbank.', roll: true },
    { r: /Rollladen mit Rohrmotor/i, g: 'abdeckung', i: 'rollladen', s: 'Motorisch aufrollbare Abdeckung – hält Schmutz fern und die Wärme im Wasser.', roll: true, lamellen: true },
    { r: /Gegenstromanlage/i, g: 'technik', i: 'strom', b: 'gegenstromanlage', s: 'Schwimmen gegen die Strömung – Training auch im kompakten Becken.' },
    { r: /Massage-Paket|Luft-Paket/i, g: 'technik', i: 'massage', s: 'Wellness im Becken mit Düsen.' }
  ];
  var GRUPPEN = [
    { k: 'becken', t: 'Beckenkörper', i: 'wand' },
    { k: 'einbau', t: 'Einbauteile und Beleuchtung', i: 'skimmer' },
    { k: 'technik', t: 'Wassertechnik und Wasserpflege', i: 'filter' },
    { k: 'abdeckung', t: 'Abdeckung und Sicherheit', i: 'schild' },
    { k: 'weitere', t: 'Weitere Optionen', i: 'info' }
  ];
  var WASSERPFLEGE = [
    { t: 'Automatische Chlor- und pH-Dosierung', s: 'Misst Redox- und pH-Wert und dosiert Chlor und pH-Korrektur automatisch.', b: 'chlor-automatik', i: 'tropfen' },
    { t: 'Salzelektrolyse mit pH-Regelung', s: 'Erzeugt das Desinfektionsmittel aus leicht salzhaltigem Wasser, mit automatischer pH-Messung und -Dosierung.', b: 'salzelektrolyse', i: 'tropfen' },
    { t: 'Noch offen – bitte beraten Sie mich', s: '', i: 'info' }
  ];
  var EINBAUFARBEN = ['Weiß', 'Sand', 'Hellgrau', 'Anthrazit', 'Bitte passend zur Beckenfarbe beraten'];

  /* ---------- Hilfsfunktionen ---------- */
  function $(s, el) { return (el || root).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function zahl(x) { return x == null || x === '' ? '' : String(Math.round(x * 100) / 100).replace('.', ','); }
  function hat(a, v) { return Array.isArray(a) && a.indexOf(v) > -1; }
  function lesen() { try { return JSON.parse(sessionStorage.getItem(SPEICHER) || 'null'); } catch (e) { return null; } }
  function schreiben() { try { sessionStorage.setItem(SPEICHER, JSON.stringify(z)); } catch (e) {} }
  function voll(d) { return d.t.indexOf(d.v) === 0 ? d.t : d.v + ' ' + d.t; }
  function kurz(d) { return d.t.replace(/^Novacomet\s+/, ''); }
  function slug(n) {
    return n.replace(/\s*\(.*$/, '').replace(/\s+RAL\s*\d{4}/i, '').trim().toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }
  function farbName(f) { return f.replace(/\s*\(.*$/, ''); }
  function farbInfo(f) { var m = f.match(/\(([^)]*)\)/); return m ? m[1] : ''; }
  function ist3D(f) { return /^3D/i.test(f); }
  function optRegel(o) { for (var i = 0; i < OPT_REGELN.length; i++) if (OPT_REGELN[i].r.test(o)) return OPT_REGELN[i]; return { g: 'weitere', i: 'info', s: '' }; }
  function bild(k) { return (cfg.optbilder || {})[k] || ''; }

  /* ---------- Zustand ---------- */
  var z = {
    lmax: '', bmax: '', nutzung: [], modell: '', wand: '', seite: '', farbe: '',
    optionen: [], lamellen: '', einbaufarbe: '', technik: false, pflege: '', abdeckung: [], optNotiz: '',
    einbauart: '', leistungen: [], zufahrt: '', zeitraum: '', einbauNotiz: '', nr: ''
  };
  var schritt = 1;
  var gesendet = !!cfg.gesendet;
  function modell() { return nachHandle[z.modell] || null; }
  function anfrageNr() {
    if (!z.nr) {
      var d = new Date(), p = function (n) { return (n < 10 ? '0' : '') + n; };
      z.nr = 'PB-' + d.getFullYear() + p(d.getMonth() + 1) + p(d.getDate()) + '-' + Math.random().toString(36).slice(2, 6).toUpperCase();
    }
    return z.nr;
  }
  function passende() {
    var l = parseFloat(z.lmax), b = parseFloat(z.bmax);
    return daten.filter(function (d) {
      if (l && d.lmax != null && d.lmax > l) return false;
      if (b && d.bmax != null && d.bmax > b) return false;
      for (var i = 0; i < z.nutzung.length; i++) if (!hat(d.bm, z.nutzung[i])) return false;
      return true;
    });
  }

  /* ---------- Schritt 1: Platz und Nutzung ---------- */
  function platz() {
    var lmaxAll = 0, bmaxAll = 0, lminAll = 99, bminAll = 99;
    daten.forEach(function (d) { if (d.lmax) { lmaxAll = Math.max(lmaxAll, d.lmax); lminAll = Math.min(lminAll, d.lmax); } if (d.bmax) { bmaxAll = Math.max(bmaxAll, d.bmax); bminAll = Math.min(bminAll, d.bmax); } });
    var lo = Math.floor(lminAll * 2) / 2, hi = Math.ceil(lmaxAll * 2) / 2, blo = Math.floor(bminAll * 10) / 10, bhi = Math.ceil(bmaxAll * 10) / 10;
    var lv = z.lmax || hi, bv = z.bmax || bhi;
    var html = '<div class="pfk__regler">' +
      '<label><span class="pfk__regler-kopf">' + I.lineal + ' Länge höchstens <b data-pfk-lwert>' + (z.lmax ? zahl(lv) + ' m' : 'beliebig') + '</b></span>' +
      '<input type="range" min="' + lo + '" max="' + hi + '" step="0.5" value="' + lv + '" data-pfk-l data-max="' + hi + '"><span class="pfk__regler-skala"><span>' + zahl(lo) + ' m</span><span>' + zahl(hi) + ' m</span></span></label>' +
      '<label><span class="pfk__regler-kopf">' + I.lineal + ' Breite höchstens <b data-pfk-bwert>' + (z.bmax ? zahl(bv) + ' m' : 'beliebig') + '</b></span>' +
      '<input type="range" min="' + blo + '" max="' + bhi + '" step="0.1" value="' + bv + '" data-pfk-b data-max="' + bhi + '"><span class="pfk__regler-skala"><span>' + zahl(blo) + ' m</span><span>' + zahl(bhi) + ' m</span></span></label></div>';
    html += '<h3>Was ist Ihnen wichtig? <small>(Mehrfachauswahl, optional)</small></h3><div class="pfk__icons">' + NUTZUNG.filter(function (n) {
      return daten.some(function (d) { return hat(d.bm, n.w); });
    }).map(function (n) {
      return '<label class="pfk__icon-kachel"><input type="checkbox" data-pfk-nutzung value="' + esc(n.w) + '"' + (hat(z.nutzung, n.w) ? ' checked' : '') + '>' +
        '<span>' + I[n.i] + '<b>' + esc(n.t) + '</b><small>' + esc(n.s) + '</small></span></label>';
    }).join('') + '</div><p class="pfk__treffer" data-pfk-treffer></p>';
    $('[data-pfk-platz]').innerHTML = html;
    treffer();
  }
  function treffer() {
    var el = $('[data-pfk-treffer]'); if (!el) return;
    var n = passende().length;
    el.innerHTML = n ? '<b>' + n + '</b> von ' + daten.length + ' Becken passen zu Ihren Angaben.' : 'Kein Becken passt zu allen Angaben – lockern Sie die Auswahl oder sehen Sie sich im nächsten Schritt alle Modelle an.';
  }

  /* ---------- Schritt 2: Modell ---------- */
  var alleZeigen = false;
  function modelle() {
    var liste = alleZeigen ? daten : passende();
    var gefiltert = liste.length !== daten.length;
    var html = '<div class="pfk__filter">' + (gefiltert ? '<span class="pfk__filterinfo">' + liste.length + ' passende Becken</span><button type="button" class="pfk__chip" data-pfk-alle>Alle ' + daten.length + ' Becken anzeigen</button>' :
      (alleZeigen && passende().length !== daten.length ? '<button type="button" class="pfk__chip" data-pfk-gefiltert>Nur passende Becken anzeigen</button>' : '')) + '</div>';
    if (!liste.length) { liste = daten; html += '<p class="pfk__warn">Kein Becken passt zu allen Angaben aus Schritt 1 – hier sind alle Modelle.</p>'; }
    html += '<div class="pfk__modelle">' + liste.map(function (d) {
      var chips = NUTZUNG.filter(function (n) { return hat(d.bm, n.w); }).map(function (n) { return '<span class="pfk__merk" title="' + esc(n.w) + '">' + I[n.i] + esc(n.w) + '</span>'; }).join('');
      return '<label class="pfk__modell"><input type="radio" name="pfk_modell" value="' + esc(d.h) + '"' + (z.modell === d.h ? ' checked' : '') + '>' +
        '<span class="pfk__modell-in">' + (d.img ? '<img src="' + esc(d.img) + '" alt="' + esc(d.alt) + '" loading="lazy" width="640" height="427">' : '<span class="pfk__noimg">Bild folgt</span>') +
        '<span class="pfk__modell-txt"><b>' + esc(kurz(d)) + '</b>' + (d.ein ? '<small>' + esc(d.ein) + '</small>' : '') +
        '<span class="pfk__fakten">' + (d.aussen ? '<span>' + I.lineal + 'Außen ' + esc(d.aussen) + '</span>' : '') + (d.wt ? '<span>' + I.tropfen + 'Wassertiefe ' + esc(d.wt) + '</span>' : '') +
        (d.treppe || d.tf ? '<span>' + I.treppe + esc(d.treppe || d.tf) + '</span>' : '') + '</span>' +
        (chips ? '<span class="pfk__merkmale">' + chips + '</span>' : '') +
        '<a href="' + esc(d.u) + '" target="_blank" rel="noopener" class="pfk__mehr">Details ansehen</a></span></span></label>';
    }).join('') + '</div>';
    $('[data-pfk-modelle]').innerHTML = html;
  }

  /* ---------- Schritt 3: Ausfuehrung ---------- */
  function ausfuehrung() {
    var d = modell(); if (!d) return;
    var fakten = [['Innenmaß', d.innen], ['Außenmaß', d.aussen], ['Wassertiefe', d.wt], ['Wasseroberfläche', d.wf ? zahl(d.wf) + ' m²' : ''], ['Wasservolumen', d.wv], ['Gewicht', d.gew], ['Beckenrand', d.rand], ['Treppe', d.treppe || d.tf]]
      .filter(function (x) { return x[1]; });
    var html = '<div class="pfk__modellkopf">' + (d.img ? '<img src="' + esc(d.img) + '" alt="' + esc(d.alt) + '" width="640" height="427">' : '') +
      '<div><b>' + esc(voll(d)) + '</b>' + (d.ein ? '<p>' + esc(d.ein) + '</p>' : '') + '<dl class="pfk__dl">' +
      fakten.map(function (x) { return '<dt>' + esc(x[0]) + '</dt><dd>' + esc(x[1]) + '</dd>'; }).join('') + '</dl><small class="pfk__klein">Angaben laut Hersteller.</small></div></div>';
    if (d.ausf && d.ausf.length) {
      html += '<h3>Poolwand</h3><p class="pfk__hilfe">Die Ausführung bestimmt Wandaufbau und Garantie des Beckenkörpers.</p><div class="pfk__karten">' +
        d.ausf.concat(['Bitte beraten Sie mich']).map(function (a, i) {
          var teile = a.split(' – '), lagen = (a.match(/(\d)-lagig/) || [])[1];
          var schicht = lagen ? '<span class="pfk__lagen">' + new Array(Number(lagen) + 1).join('<i></i>') + '</span>' : '<span class="pfk__lagen-icon">' + I.info + '</span>';
          return '<label class="pfk__karte"><input type="radio" name="pfk_wand" value="' + esc(a) + '"' + (z.wand === a ? ' checked' : '') + '>' +
            '<span class="pfk__karte-in">' + schicht + '<b>' + esc(teile[0]) + '</b>' + (teile[1] ? '<small>' + esc(teile.slice(1).join(' – ')) + '</small>' : '<small>Wir erklären Ihnen die Unterschiede im Gespräch.</small>') + '</span></label>';
        }).join('') + '</div>';
    } else {
      html += '<p class="pfk__hilfe">Für dieses Modell ist keine Auswahl der Poolwand vorgesehen.</p>';
    }
    if (d.seiten && d.seiten.length) {
      html += '<h3>Position der Treppe</h3><p class="pfk__hilfe">Dieses Modell gibt es mit Treppe rechts oder links – gesehen von der Längsseite, an der Sie stehen.</p><div class="pfk__karten pfk__karten--klein">' +
        d.seiten.map(function (s) {
          var links = /links/i.test(s);
          var skizze = '<svg viewBox="0 0 80 44" width="80" height="44" aria-hidden="true"><rect x="2" y="2" width="76" height="40" rx="3" fill="#dff1fa" stroke="currentColor" stroke-width="1.5"/>' +
            '<g fill="#fff" stroke="currentColor" stroke-width="1.2">' + (links ? '<rect x="2" y="2" width="16" height="16"/><rect x="2" y="2" width="10" height="10"/>' : '<rect x="62" y="2" width="16" height="16"/><rect x="68" y="2" width="10" height="10"/>') + '</g></svg>';
          return '<label class="pfk__karte"><input type="radio" name="pfk_seite" value="' + esc(s) + '"' + (z.seite === s ? ' checked' : '') + '><span class="pfk__karte-in">' + skizze + '<b>' + esc(s) + '</b></span></label>';
        }).join('') + '</div>';
    }
    if (d.serie && d.serie.length) html += '<div class="pfk__serie"><b>Serienmäßig:</b><ul>' + d.serie.map(function (s) { return '<li>' + esc(s) + '</li>'; }).join('') + '</ul></div>';
    $('[data-pfk-ausf]').innerHTML = html;
  }

  /* ---------- Schritt 4: Farbe ---------- */
  var farbTab = '';
  function farben() {
    var d = modell(); if (!d) return;
    var fs = d.farben || [];
    if (!fs.length) { $('[data-pfk-farben]').innerHTML = '<p class="pfk__hilfe">Für dieses Modell sind keine Farben hinterlegt – wir beraten Sie gern.</p>'; return; }
    var mono = fs.filter(function (f) { return !ist3D(f); }), d3 = fs.filter(ist3D);
    if (!farbTab) farbTab = z.farbe && ist3D(z.farbe) ? '3d' : 'mono';
    var liste = farbTab === '3d' ? d3 : mono;
    var html = '<p class="pfk__hilfe">Die Farbe prägt, wie das Wasser später wirkt. Neben dem Farbmuster sehen Sie die Wirkung im gefüllten Becken.</p>';
    if (mono.length && d3.length) {
      html += '<div class="pfk__tabs" role="tablist"><button type="button" role="tab" data-pfk-tab="mono" aria-selected="' + (farbTab === 'mono') + '">Monochrom<small>' + esc(farbInfo(mono[0]).replace(/^Monochrom,\s*/, '')) + '</small></button>' +
        '<button type="button" role="tab" data-pfk-tab="3d" aria-selected="' + (farbTab === '3d') + '">3D-Farben<small>' + esc(farbInfo(d3[0])) + '</small></button></div>';
      html += '<p class="pfk__klein pfk__temp">' + I.thermo + ' Temperaturbeständigkeit laut Hersteller: ' + (farbTab === '3d' ? '3D-Farben ' + esc(farbInfo(d3[0])) : 'Monochrom-Farben ' + esc(farbInfo(mono[0]).replace(/^Monochrom,\s*/, ''))) + ' Wassertemperatur.</p>';
    }
    var aktiv = z.farbe && hat(fs, z.farbe) ? z.farbe : '';
    html += '<div class="pfk__farbwahl"><div class="pfk__swatches">' + liste.map(function (f) {
      var b = (cfg.farbbilder || {})[slug(f)] || {};
      return '<label class="pfk__swatch"><input type="radio" name="pfk_farbe" value="' + esc(f) + '"' + (aktiv === f ? ' checked' : '') + '>' +
        '<span class="pfk__swatch-in"><span class="pfk__swatch-bild"' + (b.muster ? ' style="background-image:url(' + esc(b.muster) + ')"' : '') + '></span><b>' + esc(farbName(f)) + '</b></span></label>';
    }).join('') + '<label class="pfk__swatch"><input type="radio" name="pfk_farbe" value="Bitte beraten Sie mich"' + (z.farbe === 'Bitte beraten Sie mich' ? ' checked' : '') + '><span class="pfk__swatch-in"><span class="pfk__swatch-bild pfk__swatch-bild--frage">?</span><b>Noch unsicher</b></span></label></div>' +
      '<div class="pfk__vorschau" data-pfk-vorschau></div></div>';
    $('[data-pfk-farben]').innerHTML = html;
    vorschau();
  }
  function vorschau() {
    var el = $('[data-pfk-vorschau]'); if (!el) return;
    var f = z.farbe, b = f ? (cfg.farbbilder || {})[slug(f)] : null;
    if (!b || !b.wasser) { el.innerHTML = '<div class="pfk__vorschau-leer">' + I.farbe + '<span>Wählen Sie eine Farbe, um die Wirkung im Wasser zu sehen.</span></div>'; return; }
    el.innerHTML = '<img src="' + esc(b.wasser) + '" alt="' + esc(farbName(f)) + ' – Wirkung im Wasser" width="600" height="600"><span><b>' + esc(farbName(f)) + '</b> – Wirkung im Wasser' + (farbInfo(f) ? '<small>' + esc(farbInfo(f)) + '</small>' : '') + '</span>';
  }

  /* ---------- Schritt 5: Ausstattung ---------- */
  function zeile(typ, name, wert, titel, text, icon, bildKey, an) {
    var b = bildKey ? bild(bildKey) : '';
    return '<label class="pfk__option"><input type="' + typ + '" ' + name + ' value="' + esc(wert) + '"' + (an ? ' checked' : '') + '>' +
      '<span class="pfk__option-in">' + (b ? '<img src="' + esc(b) + '" alt="" width="72" height="72" loading="lazy">' : '<span class="pfk__option-icon">' + I[icon || 'info'] + '</span>') +
      '<span><b>' + esc(titel) + '</b>' + (text ? '<small>' + esc(text) + '</small>' : '') + '</span></span></label>';
  }
  function optionen() {
    var d = modell(); if (!d) return;
    var proGruppe = {}; (d.optionen || []).forEach(function (o) { var r = optRegel(o); (proGruppe[r.g] = proGruppe[r.g] || []).push({ o: o, r: r }); });
    var html = '';
    GRUPPEN.forEach(function (g) {
      var inhalt = '';
      (proGruppe[g.k] || []).forEach(function (x) {
        inhalt += zeile('checkbox', 'data-opt', x.o, x.o, x.r.s, x.r.i, x.r.b, hat(z.optionen, x.o));
        if (x.r.lamellen) {
          inhalt += '<div class="pfk__unter" data-pfk-lamellen' + (hat(z.optionen, x.o) ? '' : ' hidden') + '><span>Lamellen:</span>' +
            ['PVC', 'Polycarbonat (Solar)', 'Bitte beraten'].map(function (v) { return '<label class="pfk__pille"><input type="radio" name="pfk_lamellen" value="' + esc(v) + '"' + (z.lamellen === v ? ' checked' : '') + '><span>' + esc(v) + '</span></label>'; }).join('') + '</div>';
        }
      });
      if (g.k === 'einbau' && (proGruppe.einbau || []).length) {
        inhalt += '<div class="pfk__unter" data-pfk-einbaufarbe' + (einbauGewaehlt() ? '' : ' hidden') + '><span>Farbe der Einbauteile:</span>' +
          EINBAUFARBEN.map(function (v) { return '<label class="pfk__pille"><input type="radio" name="pfk_einbaufarbe" value="' + esc(v) + '"' + (z.einbaufarbe === v ? ' checked' : '') + '><span>' + esc(v) + '</span></label>'; }).join('') + '</div>';
      }
      if (g.k === 'technik') {
        inhalt = zeile('checkbox', 'data-pfk-technik', 'Filteranlage und Wassertechnik', 'Filteranlage und Wassertechnik', 'Wasseraufbereitung mit Filteranlage, Pumpe und Montagematerial – auf Wunsch mit Installation.', 'filter', '', z.technik) + inhalt;
        inhalt += '<div class="pfk__unterkopf">Wasserpflege</div>' + WASSERPFLEGE.map(function (w) { return zeile('radio', 'name="pfk_pflege"', w.t, w.t, w.s, w.i, w.b, z.pflege === w.t); }).join('');
      }
      if (g.k === 'abdeckung') {
        inhalt += zeile('checkbox', 'data-pfk-abdeckung', 'Poolüberdachung', 'Poolüberdachung', 'Schützt vor Schmutz, hält das Wasser warm und verlängert die Badesaison. Passende Modelle stellen wir Ihnen gern vor.', 'dach', '', hat(z.abdeckung, 'Poolüberdachung'));
        inhalt += zeile('checkbox', 'data-pfk-abdeckung', 'Pooldeck Atlas', 'Pooldeck Atlas', 'Begehbare Abdeckung – aus dem Pool wird bei Bedarf eine Terrassenfläche.', 'deck', '', hat(z.abdeckung, 'Pooldeck Atlas'));
        inhalt += '<div class="pfk__warn" data-pfk-sicherheit hidden>' + I.info + ' Bitte beachten: Bei Einsatz des HWL-Skimmers bietet ein Unterflur-Rollladen keinen ausreichenden Schutz für Kinder und Haustiere. Zum Schutz vor dem Hineinfallen empfiehlt der Hersteller eine Überdachung oder das Pooldeck Atlas.</div>';
      }
      if (!inhalt) return;
      html += '<fieldset class="pfk__gruppe pfk__gruppe--opt"><legend>' + I[g.i] + esc(g.t) + '</legend>' + inhalt + '</fieldset>';
    });
    html += '<label class="pfk__breit">Weitere Wünsche (z. B. Beheizung, Beleuchtung, Poolumrandung)<textarea rows="3" data-pfk-optnotiz>' + esc(z.optNotiz) + '</textarea></label>';
    $('[data-pfk-optionen]').innerHTML = html;
    sicherheit();
  }
  function einbauGewaehlt() { return z.optionen.some(function (o) { return optRegel(o).g === 'einbau' && !/Montage/i.test(o); }); }
  function sicherheit() {
    var el = $('[data-pfk-sicherheit]'); if (!el) return;
    var hwl = z.optionen.some(function (o) { return optRegel(o).hwl; }), roll = z.optionen.some(function (o) { return optRegel(o).roll; });
    el.hidden = !(hwl && roll);
  }

  /* ---------- Schritt 6: Einbau ---------- */
  function einbau() {
    var d = modell(); if (!d) return;
    var arten = ['Im Boden eingelassen'];
    if (/thalia/i.test(d.h)) arten.push('Freistehend');
    arten.push('Noch offen – bitte beraten Sie mich');
    var leist = [['Lieferung bis zum Grundstück', 'lkw'], ['Aushub und Erdarbeiten', 'bagger'], ['Einbau des Beckens', 'werkzeug'], ['Anschluss der Technik', 'filter'], ['Nur das Becken – Einbau in Eigenregie', 'haus']];
    var html = '<h3>Wie soll das Becken eingebaut werden?</h3><div class="pfk__karten pfk__karten--klein">' + arten.map(function (a) {
      return '<label class="pfk__karte"><input type="radio" name="pfk_einbauart" value="' + esc(a) + '"' + (z.einbauart === a ? ' checked' : '') + '><span class="pfk__karte-in">' + (/Boden/.test(a) ? I.bagger : /Frei/.test(a) ? I.haus : I.info) + '<b>' + esc(a) + '</b></span></label>';
    }).join('') + '</div>';
    html += '<h3>Welche Leistungen wünschen Sie? <small>(Mehrfachauswahl)</small></h3><div class="pfk__icons pfk__icons--klein">' + leist.map(function (l) {
      return '<label class="pfk__icon-kachel"><input type="checkbox" data-pfk-leistung value="' + esc(l[0]) + '"' + (hat(z.leistungen, l[0]) ? ' checked' : '') + '><span>' + I[l[1]] + '<b>' + esc(l[0]) + '</b></span></label>';
    }).join('') + '</div>';
    html += '<h3>Zufahrt zum Grundstück</h3>';
    if (d.liefer) html += '<div class="pfk__info">' + I.lkw + '<span>' + esc(d.liefer).replace(/\n/g, '<br>') + '</span></div>';
    html += '<div class="pfk__liste">' + ['Ja – LKW und Kran kommen bis an das Grundstück', 'Eingeschränkt – z. B. enge Zufahrt, Hanglage, Hinterhof', 'Weiß ich nicht'].map(function (v) {
      return '<label class="pfk__zeile"><input type="radio" name="pfk_zufahrt" value="' + esc(v) + '"' + (z.zufahrt === v ? ' checked' : '') + '><span>' + esc(v) + '</span></label>';
    }).join('') + '</div>';
    html += '<h3>Wann soll Ihr Pool fertig sein?</h3><label class="pfk__breit pfk__schmal">' + I.kalender + '<select data-pfk-zeitraum><option value="">Bitte wählen</option>' +
      ['So bald wie möglich', 'In den nächsten 3 Monaten', 'In 3 bis 6 Monaten', 'In mehr als 6 Monaten', 'Noch offen'].map(function (v) { return '<option' + (z.zeitraum === v ? ' selected' : '') + '>' + esc(v) + '</option>'; }).join('') + '</select></label>' +
      '<label class="pfk__breit">Anmerkungen zum Grundstück (optional)<textarea rows="3" data-pfk-einbaunotiz placeholder="z. B. Bodenbeschaffenheit, Gefälle, vorhandene Leitungen">' + esc(z.einbauNotiz) + '</textarea></label>';
    $('[data-pfk-einbau]').innerHTML = html;
  }

  /* ---------- Zusammenfassung ---------- */
  function zeilen() {
    var d = modell(); if (!d) return [];
    var r = [];
    var mz = [['Hersteller', d.v], ['Modell', kurz(d)]];
    if (d.ein) mz.push(['Einordnung', d.ein]);
    [['Außenmaß', d.aussen], ['Innenmaß', d.innen], ['Wassertiefe', d.wt], ['Wasservolumen', d.wv], ['Beckenrand', d.rand], ['Treppe', d.treppe || d.tf]].forEach(function (x) { if (x[1]) mz.push(x); });
    r.push(['Becken', mz]);
    var pz = [];
    if (z.lmax) pz.push(['Länge höchstens', zahl(z.lmax) + ' m']);
    if (z.bmax) pz.push(['Breite höchstens', zahl(z.bmax) + ' m']);
    if (z.nutzung.length) pz.push(['Wichtig', z.nutzung.join(', ')]);
    if (pz.length) r.push(['Platz und Wünsche', pz]);
    var az = [];
    if (z.wand) az.push(['Poolwand', z.wand]);
    if (z.seite) az.push(['Treppe', z.seite]);
    az.push(['Farbe', z.farbe ? farbName(z.farbe) + (farbInfo(z.farbe) ? ' (' + farbInfo(z.farbe) + ')' : '') : 'Beratung gewünscht']);
    r.push(['Ausführung und Farbe', az]);
    var oz = [];
    z.optionen.forEach(function (o) { oz.push(['', o + (optRegel(o).lamellen && z.lamellen ? ' – Lamellen: ' + z.lamellen : '')]); });
    if (z.einbaufarbe && einbauGewaehlt()) oz.push(['Farbe der Einbauteile', z.einbaufarbe]);
    if (z.technik) oz.push(['', 'Filteranlage und Wassertechnik']);
    if (z.pflege) oz.push(['Wasserpflege', z.pflege]);
    z.abdeckung.forEach(function (a) { oz.push(['Interesse an', a]); });
    if (z.optNotiz) oz.push(['Weitere Wünsche', z.optNotiz]);
    r.push(['Ausstattung', oz.length ? oz : [['Ausstattung', 'keine Auswahl – Beratung gewünscht']]]);
    var ez = [];
    if (z.einbauart) ez.push(['Einbau', z.einbauart]);
    if (z.leistungen.length) ez.push(['Gewünschte Leistungen', z.leistungen.join(', ')]);
    if (z.zufahrt) ez.push(['Zufahrt', z.zufahrt]);
    if (z.zeitraum) ez.push(['Fertigstellung', z.zeitraum]);
    if (z.einbauNotiz) ez.push(['Anmerkungen', z.einbauNotiz]);
    if (ez.length) r.push(['Einbau und Lieferung', ez]);
    if (d.serie && d.serie.length) r.push(['Serienmäßig', d.serie.map(function (s) { return ['', s]; })]);
    return r;
  }
  function uebersicht() {
    var d = modell(); if (!d) return;
    var b = z.farbe ? (cfg.farbbilder || {})[slug(z.farbe)] : null;
    var html = '<div class="pfk__uebersicht"><div class="pfk__uebersicht-bilder">' + (d.img ? '<img src="' + esc(d.img) + '" alt="' + esc(d.alt) + '" width="640" height="427">' : '') +
      (b && b.wasser ? '<div class="pfk__farbstreifen"><span style="background-image:url(' + esc(b.muster) + ')"></span><span style="background-image:url(' + esc(b.wasser) + ')"></span><small>' + esc(farbName(z.farbe)) + '</small></div>' : '') + '</div><div>';
    zeilen().forEach(function (blk) {
      html += '<h3>' + esc(blk[0]) + '</h3><dl>' + blk[1].map(function (x) { return (x[0] ? '<dt>' + esc(x[0]) + '</dt>' : '<dt>✓</dt>') + '<dd>' + esc(x[1]) + '</dd>'; }).join('') + '</dl>';
    });
    html += '<p class="pfk__klein">Alle technischen Angaben laut Hersteller. Die Konfiguration ist eine unverbindliche Anfrage – Ihr persönliches Angebot erhalten Sie von uns.</p>';
    $('[data-pfk-uebersicht]').innerHTML = html + '</div></div>';
  }
  function kunde() {
    var f = $('[data-pfk-form]'); if (!f) return {};
    function w(n) { var el = f.querySelector('[name="contact[' + n + ']"]'); return el ? el.value.trim() : ''; }
    return { anrede: w('Anrede'), vorname: w('Vorname'), nachname: w('Nachname'), email: w('email'), telefon: w('Telefon'),
      strasse: w('Strasse'), plz: w('PLZ'), ort: w('Ort'), land: w('Land'), quelle: w('Quelle'), nachricht: w('Nachricht') };
  }
  function klartext() {
    var t = 'KONFIGURATION GFK-POOL\nAnfrage-Nr.: ' + anfrageNr() + '\n';
    zeilen().forEach(function (blk) { t += '\n' + blk[0].toUpperCase() + '\n'; blk[1].forEach(function (x) { t += (x[0] ? x[0] + ': ' : '- ') + x[1] + '\n'; }); });
    var d = modell(); if (d) t += '\nProduktseite: ' + (cfg.web || '') + d.u + '\n';
    return t;
  }

  /* ---------- Navigation ---------- */
  function fehler(txt) { var el = $('[data-pfk-meldung]'); if (el) el.textContent = txt || ''; return !txt; }
  function pruefen(s) {
    var d = modell();
    if (s === 2 && !d) return fehler('Bitte wählen Sie ein Becken.');
    if (s === 3) {
      if (d.ausf && d.ausf.length && !z.wand) return fehler('Bitte wählen Sie die Poolwand.');
      if (d.seiten && d.seiten.length && !z.seite) return fehler('Bitte wählen Sie die Position der Treppe.');
    }
    if (s === 4 && d.farben && d.farben.length && !z.farbe) return fehler('Bitte wählen Sie eine Farbe – oder „Noch unsicher“.');
    if (s === 6 && !z.einbauart) return fehler('Bitte geben Sie an, wie das Becken eingebaut werden soll.');
    return fehler('');
  }
  function sendenPruefen() {
    var sen = $('[data-pfk-senden]'), s8 = $('[data-schritt="' + MAX + '"]');
    if (!sen || !s8) return;
    var ok = schritt === MAX && $$('input,select,textarea', s8).every(function (el) { return el.checkValidity(); });
    sen.disabled = !ok;
    sen.title = ok ? '' : 'Bitte füllen Sie alle Pflichtfelder aus und bestätigen Sie die Datenschutzerklärung.';
  }
  function zeigen(s) {
    schritt = s;
    $$('[data-schritt]').forEach(function (el) { el.hidden = Number(el.getAttribute('data-schritt')) !== s; });
    $$('[data-pfk-leiste] li').forEach(function (li) { var n = Number(li.getAttribute('data-s')); li.className = n === s ? 'ist-aktiv' : (n < s ? 'ist-fertig' : ''); });
    if (s === 1) platz();
    if (s === 2) modelle();
    if (s === 3) ausfuehrung();
    if (s === 4) farben();
    if (s === 5) optionen();
    if (s === 6) einbau();
    if (s === 7) uebersicht();
    var zur = $('[data-pfk-zurueck]'), wei = $('[data-pfk-weiter]'), sen = $('[data-pfk-senden]');
    if (zur) zur.hidden = s === 1;
    if (wei) { wei.hidden = s === MAX; wei.textContent = s === 1 ? 'Passende Becken ansehen' : (s === 7 ? 'Weiter zur Anfrage' : 'Weiter'); }
    if (sen) sen.hidden = s !== MAX;
    sendenPruefen();
    fehler('');
    schreiben();
    var kopf = root.getBoundingClientRect().top + window.pageYOffset - 90;
    if (window.pageYOffset > kopf) window.scrollTo({ top: kopf, behavior: 'smooth' });
  }

  /* ---------- Ereignisse ---------- */
  function neuesModell(h) {
    if (z.modell === h) return;
    z.modell = h; z.wand = ''; z.seite = ''; z.optionen = []; z.lamellen = ''; z.einbaufarbe = ''; farbTab = '';
    var d = modell(); if (z.farbe && d && !hat(d.farben, z.farbe) && z.farbe !== 'Bitte beraten Sie mich') z.farbe = '';
    if (d && d.ausf && d.ausf.length === 1) z.wand = d.ausf[0];
    if (z.einbauart === 'Freistehend' && d && !/thalia/i.test(d.h)) z.einbauart = '';
  }
  root.addEventListener('input', function (e) {
    var t = e.target;
    if (t.hasAttribute('data-pfk-l') || t.hasAttribute('data-pfk-b')) {
      var istL = t.hasAttribute('data-pfk-l'), ganz = parseFloat(t.value) >= parseFloat(t.getAttribute('data-max'));
      z[istL ? 'lmax' : 'bmax'] = ganz ? '' : t.value;
      var anz = $(istL ? '[data-pfk-lwert]' : '[data-pfk-bwert]'); if (anz) anz.textContent = ganz ? 'beliebig' : zahl(parseFloat(t.value)) + ' m';
      alleZeigen = false; treffer();
    }
    if (t.hasAttribute('data-pfk-optnotiz')) z.optNotiz = t.value;
    if (t.hasAttribute('data-pfk-einbaunotiz')) z.einbauNotiz = t.value;
    sendenPruefen(); schreiben();
  });
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.hasAttribute('data-pfk-nutzung')) { z.nutzung = $$('[data-pfk-nutzung]:checked').map(function (x) { return x.value; }); alleZeigen = false; treffer(); }
    if (t.name === 'pfk_modell') { neuesModell(t.value); schreiben(); zeigen(3); return; }
    if (t.name === 'pfk_wand') z.wand = t.value;
    if (t.name === 'pfk_seite') z.seite = t.value;
    if (t.name === 'pfk_farbe') { z.farbe = t.value; vorschau(); }
    if (t.hasAttribute('data-opt')) {
      z.optionen = $$('[data-opt]:checked').map(function (x) { return x.value; });
      var lam = $('[data-pfk-lamellen]'); if (lam) lam.hidden = !z.optionen.some(function (o) { return optRegel(o).lamellen; });
      var ef = $('[data-pfk-einbaufarbe]'); if (ef) ef.hidden = !einbauGewaehlt();
      sicherheit();
    }
    if (t.name === 'pfk_lamellen') z.lamellen = t.value;
    if (t.name === 'pfk_einbaufarbe') z.einbaufarbe = t.value;
    if (t.hasAttribute('data-pfk-technik')) z.technik = t.checked;
    if (t.name === 'pfk_pflege') z.pflege = t.value;
    if (t.hasAttribute('data-pfk-abdeckung')) z.abdeckung = $$('[data-pfk-abdeckung]:checked').map(function (x) { return x.value; });
    if (t.name === 'pfk_einbauart') z.einbauart = t.value;
    if (t.hasAttribute('data-pfk-leistung')) {
      var eigen = 'Nur das Becken – Einbau in Eigenregie';
      if (t.value === eigen && t.checked) $$('[data-pfk-leistung]').forEach(function (x) { if (x.value !== eigen && x.value !== 'Lieferung bis zum Grundstück') x.checked = false; });
      if (t.value !== eigen && t.value !== 'Lieferung bis zum Grundstück' && t.checked) $$('[data-pfk-leistung]').forEach(function (x) { if (x.value === eigen) x.checked = false; });
      z.leistungen = $$('[data-pfk-leistung]:checked').map(function (x) { return x.value; });
    }
    if (t.name === 'pfk_zufahrt') z.zufahrt = t.value;
    if (t.hasAttribute('data-pfk-zeitraum')) z.zeitraum = t.value;
    sendenPruefen(); schreiben();
  });
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-pfk-alle]')) { alleZeigen = true; modelle(); return; }
    if (e.target.closest('[data-pfk-gefiltert]')) { alleZeigen = false; modelle(); return; }
    var tab = e.target.closest('[data-pfk-tab]'); if (tab) { farbTab = tab.getAttribute('data-pfk-tab'); farben(); return; }
    if (e.target.closest('[data-pfk-weiter]')) { if (pruefen(schritt)) zeigen(Math.min(MAX, schritt + 1)); return; }
    if (e.target.closest('[data-pfk-zurueck]')) { zeigen(Math.max(1, schritt - 1)); return; }
    if (e.target.closest('[data-pfk-pdf]')) { e.preventDefault(); pdfErstellen(false).then(function (doc) { if (doc) doc.save(dateiname()); }); return; }
    var li = e.target.closest('[data-pfk-leiste] li');
    if (li && !gesendet) {
      var ziel = Number(li.getAttribute('data-s'));
      if (ziel < schritt) zeigen(ziel);
      else { for (var s = schritt; s < ziel; s++) { if (!pruefen(s)) { zeigen(s); pruefen(s); return; } } zeigen(ziel); }
    }
  });

  /* ---------- Absenden ---------- */
  var form = $('[data-pfk-form]');
  var sendetGerade = false;
  if (form && !gesendet) {
    form.addEventListener('submit', function (e) {
      if (sendetGerade) { e.preventDefault(); return; }
      for (var s = 1; s < MAX; s++) { if (!pruefen(s)) { e.preventDefault(); zeigen(s); pruefen(s); return; } }
      var k = kunde();
      var txt = klartext() + '\nKONTAKT\n' + [k.anrede, k.vorname, k.nachname].filter(Boolean).join(' ') + '\n' + k.email + '\n' + k.telefon + '\n' +
        [k.strasse, [k.plz, k.ort].filter(Boolean).join(' '), k.land].filter(Boolean).join(', ') + (k.nachricht ? '\n\nNachricht:\n' + k.nachricht : '');
      var d = modell();
      z.kunde = k; schreiben();
      e.preventDefault();
      if (!cfg.versand) { rueckfall(k, txt, d); return; }
      sendetGerade = true;
      var btn = $('[data-pfk-senden]'); if (btn) { btn.disabled = true; btn.textContent = 'Wird gesendet …'; }
      pdfErstellen(true).then(function (doc) {
        var hp = $('[data-pfk-hp]');
        var nutz = { art: cfg.art || 'GFK-Pool', anfrage: anfrageNr(), kunde: k, modell: d ? voll(d) : '', produkt: d ? (cfg.web || '') + d.u : '',
          bloecke: zeilen(), konfiguration: klartext(), dateiname: dateiname(), website: hp ? hp.value : '',
          pdf: doc ? doc.output('datauristring').split(',')[1] : null };
        var zeit = new Promise(function (ok) { setTimeout(function () { ok(null); }, 25000); });
        return Promise.race([fetch(cfg.versand, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(nutz) })
          .then(function (r) { return r.ok ? r.json().catch(function () { return null; }) : null; }).catch(function () { return null; }), zeit]);
      }).then(function (antwort) {
        if (antwort && antwort.ok) { z.mailOk = antwort.kunde !== false; schreiben(); dankeZeigen(); }
        else { z.mailOk = false; schreiben(); rueckfall(k, txt, d); }
      }).catch(function () { rueckfall(k, txt, d); });
    });
  }
  /* Rueckfall: Shopify-Kontaktformular (E-Mail an die Shop-Adresse). Shopify kann dabei eine Sicherheitsabfrage zeigen. */
  function rueckfall(k, txt, d) {
    var fb = document.querySelector('[data-pfk-fallback]');
    if (!fb) { fehler('Die Anfrage konnte nicht gesendet werden. Bitte schreiben Sie uns an ' + (cfg.mail || '') + '.'); return; }
    function setz(n, v) { var el = fb.querySelector('[data-fb="' + n + '"]'); if (el) el.value = v || ''; }
    setz('email', k.email); setz('name', [k.vorname, k.nachname].filter(Boolean).join(' ')); setz('telefon', k.telefon);
    setz('modell', d ? voll(d) + ' (' + anfrageNr() + ')' : ''); setz('body', txt);
    if (fb.requestSubmit) fb.requestSubmit(); else fb.submit();
  }

  function dankeZeigen() {
    gesendet = true;
    form.innerHTML = '<section class="pfk__schritt pfk__danke"><h2>Vielen Dank für Ihre Anfrage!</h2>' +
      '<p>Ihre Pool-Konfiguration ist bei uns eingegangen. Wir prüfen Ihre Angaben und melden uns in Kürze mit einem persönlichen Angebot bei Ihnen.</p>' +
      (z.mailOk ? '<p>Eine Bestätigung mit Ihrer Konfiguration als PDF haben wir Ihnen per E-Mail gesendet.</p>' : '<p>Ihre Konfiguration können Sie hier als PDF herunterladen.</p>') +
      '<div class="pfk__aktionen"><button type="button" class="pfw__btn" data-pfk-pdf>Konfiguration als PDF herunterladen</button>' +
      '<a class="pfw__btn pfw__btn--ghost" href="' + esc(cfg.zurueck || '/collections/rechteckbecken') + '">Zu den Fertigbecken</a></div></section>';
    $$('[data-pfk-leiste] li').forEach(function (li) { li.className = 'ist-fertig'; });
    window.scrollTo({ top: root.getBoundingClientRect().top + window.pageYOffset - 90, behavior: 'smooth' });
  }

  /* ---------- PDF ---------- */
  function dateiname() { var d = modell(); return 'Poolfritz-Pool-Konfiguration-' + (d ? kurz(d).replace(/[^A-Za-z0-9]+/g, '-') : 'Becken') + '-' + anfrageNr() + '.pdf'; }
  var jspdfLaden = null;
  function ladeJsPDF() {
    if (window.jspdf) return Promise.resolve(window.jspdf.jsPDF);
    if (!jspdfLaden) jspdfLaden = new Promise(function (ok, nein) {
      var s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
      s.onload = function () { ok(window.jspdf.jsPDF); }; s.onerror = nein; document.head.appendChild(s);
    });
    return jspdfLaden;
  }
  function bildLaden(url, format) {
    return new Promise(function (ok) {
      if (!url) return ok(null);
      var img = new Image(); img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var c = document.createElement('canvas'); c.width = img.naturalWidth; c.height = img.naturalHeight;
          var cx = c.getContext('2d');
          if (format === 'JPEG') { cx.fillStyle = '#fff'; cx.fillRect(0, 0, c.width, c.height); }
          cx.drawImage(img, 0, 0);
          ok({ data: c.toDataURL(format === 'JPEG' ? 'image/jpeg' : 'image/png', 0.85), w: c.width, h: c.height });
        } catch (e) { ok(null); }
      };
      img.onerror = function () { ok(null); };
      img.src = (url.indexOf('//') === 0 ? 'https:' : '') + url;
    });
  }
  function pdfErstellen(still) {
    var d = modell();
    if (!d) return Promise.resolve(null);
    var fb = z.farbe ? (cfg.farbbilder || {})[slug(z.farbe)] : null;
    var btns = $$('[data-pfk-pdf]'); btns.forEach(function (b) { b.disabled = true; });
    return Promise.all([ladeJsPDF(), bildLaden(cfg.logo, 'PNG'), bildLaden(d.pdfimg || d.img, 'JPEG'), bildLaden(fb && fb.pdf, 'JPEG'), bildLaden(fb && fb.wasser, 'JPEG')]).then(function (r) {
      var doc = pdfBauen(r[0], r[1], r[2], r[3], r[4], d);
      btns.forEach(function (b) { b.disabled = false; });
      return doc;
    }).catch(function () {
      btns.forEach(function (b) { b.disabled = false; });
      if (!still) fehler('Das PDF konnte gerade nicht erstellt werden. Bitte versuchen Sie es erneut.');
      return null;
    });
  }
  function pdfBauen(JsPDF, logo, bildP, muster, wasser, d) {
    var doc = new JsPDF({ unit: 'mm', format: 'a4' });
    var L = 18, R = 192, y = 16, BLAU = [6, 20, 46], GRAU = [110, 116, 124], LINIE = [220, 224, 228];
    var heute = new Date().toLocaleDateString('de-DE');
    function kopf() {
      if (logo) { var lw = Math.min(60, 16 * logo.w / logo.h); doc.addImage(logo.data, 'PNG', L, 10, lw, lw * logo.h / logo.w); }
      else { doc.setFont('helvetica', 'bold'); doc.setFontSize(18); doc.setTextColor.apply(doc, BLAU); doc.text(cfg.shop || 'Poolfritz', L, 20); }
      doc.setFont('helvetica', 'normal'); doc.setFontSize(9); doc.setTextColor.apply(doc, GRAU);
      doc.text('Anfrage-Nr. ' + anfrageNr(), R, 14, { align: 'right' }); doc.text('Datum ' + heute, R, 19, { align: 'right' });
      doc.setDrawColor.apply(doc, LINIE); doc.line(L, 30, R, 30); y = 38;
    }
    function neueSeite(b) { if (y + b > 275) { doc.addPage(); kopf(); } }
    kopf();
    doc.setFont('helvetica', 'bold'); doc.setFontSize(20); doc.setTextColor.apply(doc, BLAU); doc.text('Ihr GFK-Pool', L, y); y += 7;
    doc.setFont('helvetica', 'normal'); doc.setFontSize(11); doc.setTextColor(60, 60, 60);
    doc.text(voll(d) + (d.aussen ? '  ·  Außenmaß ' + d.aussen : ''), L, y); y += 6;
    if (bildP) {
      var bw = R - L, bh = bw * bildP.h / bildP.w; if (bh > 80) { bh = 80; bw = bh * bildP.w / bildP.h; }
      doc.addImage(bildP.data, 'JPEG', L + (R - L - bw) / 2, y, bw, bh); y += bh + 3;
      doc.setFontSize(8); doc.setTextColor.apply(doc, GRAU); doc.text('Abbildung ähnlich, Beispielfoto des Herstellers.', L, y + 1); y += 7;
    }
    if (muster || wasser) {
      neueSeite(40);
      doc.setFont('helvetica', 'bold'); doc.setFontSize(11); doc.setTextColor.apply(doc, BLAU); doc.text('Ihre Farbe: ' + farbName(z.farbe), L, y); y += 3;
      if (muster) doc.addImage(muster.data, 'JPEG', L, y, 28, 28);
      if (wasser) doc.addImage(wasser.data, 'JPEG', L + 32, y, 28, 28);
      doc.setFont('helvetica', 'normal'); doc.setFontSize(8.5); doc.setTextColor.apply(doc, GRAU);
      doc.text('Farbmuster', L, y + 32); doc.text('Wirkung im Wasser', L + 32, y + 32);
      if (farbInfo(z.farbe)) doc.text(doc.splitTextToSize('Temperaturbeständigkeit laut Hersteller: ' + farbInfo(z.farbe).replace(/^Monochrom,\s*/, ''), 100), L + 68, y + 6);
      y += 40;
    }
    var k2 = z.kunde || kunde(), bloecke = zeilen(), kz = [];
    var name = [k2.anrede, k2.vorname, k2.nachname].filter(Boolean).join(' ');
    if (name) kz.push(['Name', name]); if (k2.email) kz.push(['E-Mail', k2.email]); if (k2.telefon) kz.push(['Telefon', k2.telefon]);
    var adr = [k2.strasse, [k2.plz, k2.ort].filter(Boolean).join(' '), k2.land].filter(Boolean).join(', ');
    if (k2.strasse || k2.plz || k2.ort) kz.push(['Adresse', adr]);
    if (k2.nachricht) kz.push(['Nachricht', k2.nachricht]);
    if (kz.length) bloecke.push(['Ihre Kontaktdaten', kz]);
    bloecke.forEach(function (blk) {
      neueSeite(16);
      doc.setFont('helvetica', 'bold'); doc.setFontSize(11); doc.setTextColor.apply(doc, BLAU); doc.text(blk[0], L, y); y += 2;
      doc.setDrawColor.apply(doc, LINIE); doc.line(L, y, R, y); y += 5;
      blk[1].forEach(function (x) {
        doc.setFontSize(9.5);
        var wert = doc.splitTextToSize(String(x[1]), x[0] ? 112 : 168), lab = x[0] ? doc.splitTextToSize(x[0], 56) : ['–'];
        neueSeite(Math.max(wert.length, lab.length) * 4.4 + 2);
        doc.setFont('helvetica', 'normal'); doc.setTextColor.apply(doc, GRAU); doc.text(lab, x[0] ? L : L + 2, y);
        doc.setTextColor(30, 30, 30); doc.text(wert, x[0] ? L + 62 : L + 8, y);
        y += Math.max(wert.length, lab.length) * 4.4 + 1.6;
      });
      y += 4;
    });
    neueSeite(20);
    doc.setFont('helvetica', 'normal'); doc.setFontSize(8.5); doc.setTextColor.apply(doc, GRAU);
    doc.text(doc.splitTextToSize('Diese Konfiguration ist eine unverbindliche Anfrage und kein Angebot. Alle technischen Angaben laut Hersteller, technische Änderungen vorbehalten. Lieferung, Einbau und Montage sind nicht im Beckenpreis enthalten und werden im Angebot gesondert ausgewiesen.', R - L), L, y);
    var seiten = doc.getNumberOfPages();
    for (var i = 1; i <= seiten; i++) {
      doc.setPage(i); doc.setFontSize(8); doc.setTextColor.apply(doc, GRAU); doc.setDrawColor.apply(doc, LINIE); doc.line(L, 283, R, 283);
      doc.text([cfg.shop || 'Poolfritz', cfg.mail, cfg.telefon, (cfg.web || '').replace(/^https?:\/\//, '')].filter(Boolean).join('  ·  '), L, 288);
      doc.text('Seite ' + i + ' von ' + seiten, R, 288, { align: 'right' });
    }
    return doc;
  }

  /* ---------- Start ---------- */
  if (gesendet) {
    var alt = lesen();
    if (alt && alt.modell && nachHandle[alt.modell]) {
      z = alt;
      $$('[data-pfk-pdf]').forEach(function (b) { b.hidden = false; });
      if (z.mailOk) { var m = $('[data-pfk-danke-mail]'); if (m) m.hidden = false; }
    }
    $$('[data-pfk-leiste] li').forEach(function (li) { li.className = 'ist-fertig'; });
    return;
  }
  var params = new URLSearchParams(window.location.search);
  var gespeichert = lesen();
  if (gespeichert && !params.get('modell')) { for (var k in gespeichert) if (k in z) z[k] = gespeichert[k]; }
  var vorwahl = params.get('modell');
  if (vorwahl && nachHandle[vorwahl]) { neuesModell(vorwahl); z.nr = ''; zeigen(3); }
  else zeigen(z.modell && modell() ? 2 : 1);
})();
